import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import useStyles from './Content7.styled'

export const useContent7 = props => {
	const { className, metaData } = props
	const classes = useStyles(props)
	const { handleFocus: handleTitleClick } = useFieldFocus({ metaData: metaData.title })

	const { editable: titleEditable, handleChange: handleTitleChange } = useEditorMeta({
		metaData: metaData.title,
		key: 'title',
	})

	return [
		{
			className,
			classes,
			title: metaData.title?.metaValue,
			titleConfig: metaData.title?.config,
			shareText: metaData.share_text?.metaValue,
			shareLinks: {
				show_facebook_link: metaData.show_facebook_link?.toBoolean(),
				show_twitter_link: metaData.show_twitter_link?.toBoolean(),
				show_linkedin_link: metaData.show_linkedin_link?.toBoolean(),
			},
			titleEditable,
			titleKey: metaData.title?.tierKey,
		},
		{
			handleTitleClick,
			handleTitleChange,
		},
	]
}
